<template>
  <div>
	<p class="fz-24 text-center my-48" v-if="showNoResults">No Search Results for '{{searchString}}'</p>
    <div class="row" v-if="!showNoResults"> 
      <div class="col-lg-4 post-item mb-4 animated fadeInUp" v-for="post in posts" :key="post.ID">
         <div class="shadow">
          <a :href="post.link" class="text-decoration-none" :target="post.link_post_url_target">
            <div class="card shadow-sm h-100">
				<div class="bg-image-wrap">
					<div class="bg-image" :style="{backgroundImage: `url(${post.image_url})`}"></div>
				</div>
              <div class="card-body bg-white py-36 px-48 rounded-bottom">
                <div class="d-flex flex-column justify-content-between h-100">
                  <div>
                    <h6 class="color-windward-blue text-uppercase">{{post.main_category}}</h6>
                    <h4 class="card-title not-upper">{{post.post_title}}</h4>
                  </div>
                </div>
              </div>
            </div> 
          </a>
        </div>
      </div>
    </div>
    <div class="row" style="overflow-anchor: none;">
      <button class="btn btn-windward-blue mx-auto" @click.stop.prevent="loadMore()" v-if="showLoadMore">Load More</button>
    </div>
  </div>
</template>
<script>
const axios = require('axios');
export default {
	created(){
		this.getPosts();
		this.showLoadMore = false;
	},
	mounted(){
		this.showLoadMore = true;
	},
	methods: {
		getPostRequest(category = 'all', page = 0, take = 12, search = ''){
			this.showNoResults = false;
			if(window.app.category) category = window.app.category;
			return axios.get(`${this.api.prefix}${this.api.posts}?page=${page}&take=${take}&category=${category}&search=${search}`);
		},
		getPosts(category = 'all', page = 0, take = 12){
			this.$set(this, 'loading', true);
				this.getPostRequest(category, page, take)
				.then(posts => {
					this.$set(this, 'loading', false);
					this.delayedInsert(this.posts, posts.data);
					if(posts.data.length < take){
						this.showLoadMore = false;
					}
				}).catch(err => {
					this.$set(this, 'loading', false);
				});
		},
		loadMore(){
			this.$set(this, 'page', this.page + 1);
			this.getPosts([this.category], this.page);
		},
		searchPosts(searchString){
			this.$set(this, 'category', 'all');
			this.$set(this, 'page', 1);
			this.$set(this, 'searchString', searchString);
			this.$set(this, 'loading', true);
			this.getPostRequest(this.category, 1, 12, searchString).then(response => {
				this.$set(this, 'loading', false);
				this.$set(this, 'posts', []);
				if(response.data.length == 0){
					this.showNoResults = true;
				}
				this.delayedInsert(this.posts, response.data);
				if(response.data.length < 12){
					this.showLoadMore = false;
				} else{
					setTimeout(() => {
						this.showLoadMore = true;
					}, 300);
				}
			});
			app.scroll.toTarget('.section-blog_posts');
		},
		setCategory(id){
			this.$set(this, 'category', id);
			this.$set(this, 'page', 1);
			this.$set(this, 'loading', true);
			this.getPostRequest(this.category).then(response => {
				this.$set(this, 'loading', false);
				this.$set(this, 'posts', []);
				this.delayedInsert(this.posts, response.data);
				if(response.data.length < 12){
					this.showLoadMore = false;
				} else{
					setTimeout(() => {
						this.showLoadMore = true;
					}, 300);
				}
			});
			app.scroll.toTarget('.section-blog_posts');
		},
		delayedInsert(subject, items){
			const [item, ...rest] = items;
			subject.push(item);
			if (rest.length > 0){
				setTimeout(() => {
					this.delayedInsert(subject, rest);
				}, 80);
			}
		},
		setMode(mode){
			this.$set(this, 'mode', mode);
		},
		json(j){
			return JSON.stringify(j);
		}
	},
	data() {
		return {
			posts: [],
			categories: [],
			category: 'all',
			loading: true,
			api: {
				prefix: '/wp-json/usdp/v1/',
				posts: 'posts/',
				projectCategories: 'posts/categories/',
			},
			page: 1,
			searchString: '',
			showNoResults: false,
			mode: 'grid'
		};
	}
}
</script>
